import { AfterContentInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { Configuration } from 'src/app/domain/configuration';
import { ProductGroup } from 'src/app/domain/product-group';
import { TestGroup } from 'src/app/domain/test-group';
import { UserService } from 'src/app/services/user.service';
import { PreventDoubleClickDirective } from '../../directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-test-group-box',
    templateUrl: './test-group-box.component.html',
    styleUrl: './test-group-box.component.scss',
    standalone: true,
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, FormsModule, MatSlideToggleModule, MatButtonModule, PreventDoubleClickDirective]
})
export class TestGroupBoxComponent implements OnInit, AfterContentInit {

    Model: TestGroup = new TestGroup();
    IsCreation: boolean = true;
    CanUseIsDefault: boolean = true;
    CanUseIsHidden: boolean = true;

    constructor(
        public dialogRef: MatDialogRef<TestGroupBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        if (data) {
            this.CanUseIsDefault = data.canUseIsDefault;
            this.CanUseIsHidden = data.canUseIsHidden;
        }
        if (data.tg) {
            this.Model = Object.assign({}, data.tg);
            this.IsCreation = false;
        }
    }
    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

    }

    CanSave() {
        return true;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }
}
